import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { Doc, DocumentTypeListDto, Notify, PdfDto, Personel, PersonelList, PersonelLogin, SignInDto, UserMessageModel, UserPermissionsDto } from '../models/Personel';
import { stringify } from 'querystring';



/*
const LoginhttpOptions = {
  headers: new HttpHeaders({
      'Content-Type':  'application/json','No-Auth':'True','Access-Control-Allow-Origin': '*'
  })
};*/


@Injectable({
  providedIn: 'root'
})
export class PersonelService {
  //local test
  //readonly rootUrl = 'http://192.168.3.249:116/';
  //public test
  //readonly rootUrl = 'http://78.189.86.247:116/';
  //tekpan
  readonly rootUrl = 'http://personelapi.tekpan.com.tr/';


  //storage e personeli eklemeyi unutma auth kontrol
  /*  if (user && user.access_token) {             
             
                localStorage.setItem('currentUser', JSON.stringify(user));                
               localStorage.setItem('userToken',user.access_token);
               localStorage.setItem('userRoles',user.role);
              
            }*/

  constructor(private http: HttpClient) { }

  userLogin(signin: SignInDto): Observable<PersonelLogin> {
    const login = `username=${signin.userName}&password=${signin.password}&grant_type=password`;

    //const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json' });

    //return this.http.post<PersonelLogin>(this.rootUrl+'Token', login, { headers: reqHeader });
    return this.http.post<PersonelLogin>(this.rootUrl + 'Token', login);//, LoginhttpOptions);
  }

  getToken(): string {
    
    let user: PersonelLogin = JSON.parse(localStorage.getItem('personelInfo'));
    if(user != null){
      return user.access_token;
    }else{
      return null;
    }
    
  }

  logoutServerSide(){
    return this.http.get<any>(this.rootUrl + 'api/Account/Logout');
  }

  getDocumentList(type: string) {

    let obj = {
      DocumentTypeId: type,
    };
    return this.http.post<Doc[]>(this.rootUrl + 'api/document/notconfirmdocumentlist', obj);
  }

  getDocument(docId: string) {
    return this.http.get<any>(this.rootUrl + 'api/document/userpdf?id=' + docId, { responseType: 'blob' as 'json' });

  }

  checkReadMessage(messageId:number){
    return this.http.get<any[]>(this.rootUrl + 'api/message/confirm?id='+messageId);
  }

  getMessagesAdmin(){
    return this.http.get<any>(this.rootUrl + 'api/message/alllist');
  }

  getMessageNotify(){
    return this.http.get<Notify[]>(this.rootUrl + 'api/message/userlist');
  }
  checkDocument(docId:number){
    let obj = {
      UserDocumentId : docId,
    };
    return this.http.post<any>(this.rootUrl + 'api/document/confirmdocument', obj);
  }

  getUserPermissions(){
    return this.http.get<UserPermissionsDto[]>(this.rootUrl + 'api/document/userpermissions');
  }

  resetPassword(personel: Personel) {
    let obj = {
      UserId:personel.Id,
      NewPassword:personel.SgkNumber,
      ConfirmPassword:personel.SgkNumber,
    };
    return this.http.post<any>(this.rootUrl + 'api/Account/SetAdminPassword', obj);
  }

  changePasword(pass:string,passRepeat:string){
    let obj = {
      NewPassword:pass,
      ConfirmPassword:passRepeat,
    };

    return this.http.post<any>(this.rootUrl + 'api/Account/SetPassword',obj);
  }

  changeActivity(personel:Personel){
    
    let obj = {
      UserId:personel.Id,
    }

    return this.http.post<any>(this.rootUrl + 'api/Account/RemoveLogin', obj);
  }

  getTypes() {
    return this.http.get<Array<DocumentTypeListDto>>(this.rootUrl + 'api/document/typelist');
  }

  getUserList(token: string): Observable<Array<Personel>> {
    //const login = `token=${token}`;
    return this.http.post<Array<Personel>>(this.rootUrl + 'api/Account/UserList', "");//,LoginhttpOptions);            
  }

  updateUser(personel: any) {

    return this.http.post<Personel>(this.rootUrl + 'api/Account/UpdateUser', personel);//,LoginhttpOptions);
  }

  sendPdf(formData:FormData){
    return this.http.post<any>(this.rootUrl + 'api/document/upload', formData);//,LoginhttpOptions);
  }

  registerUser(personel:any){
    return this.http.post<Personel>(this.rootUrl + '/api/Account/Register', personel);
  }

  createMessage(message:UserMessageModel){
    return this.http.post<any>(this.rootUrl + 'api/message/createmessage', message);
  }

  checkPersonel(tc: string, pass: string): Observable<Personel> {
    return this.http.post<Personel>(this.rootUrl + 'api/Personel', "");//,LoginhttpOptions,);            
  }

}